import { Component, ElementRef, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { keys } from 'highcharts';
import { AccessTokenService } from 'src/app/services/access-token.service';
import { LoginService } from 'src/app/services/login.service';
import { SocketService } from 'src/app/services/socket.service';
import { ValidationService } from 'src/app/services/validation.service';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-keys',
    templateUrl: './keys.component.html',
    styleUrls: ['./keys.component.css'],
    standalone: true,
    imports: [TranslateModule, FormsModule]
})
export class KeysComponent implements OnInit {
  public Noaccesstokens: boolean = true;
  public showToken: boolean = false;
  public showGeneratedtoken: boolean = false;
  public copytoken: boolean = false;
  inputValue: any
  displayToken:any
  showMessage: boolean = false;
  generateForm: any = {
    title: ''
  };
  accessTokenTitles: any[] = []
  newToken=null;

  disaplykeyGenarted:boolean=true
  currentUser: any;

  constructor(
    private accessTokenService: AccessTokenService,
    private validationService: ValidationService,
    private elementRef: ElementRef,
    private loginService:LoginService,
    private socketService: SocketService,
    private router:Router
  ) 
  {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);



  }

  ngOnInit(): void {

  

    this.updateTokens();
    
// this.accessTokenTitles.length


    
  }



  creatKey() {
    // for no token is generated then show
    if (this.showToken == false) {
      this.showToken = true;
    } else {
      this.showToken = false;
    }
    if (this.Noaccesstokens == true) {
      this.Noaccesstokens = false;
    }
    else {
      this.Noaccesstokens = true;
    }
    // for after token create  click button creatkey() 
    if (this.showGeneratedtoken == true && this.Noaccesstokens == true) {
      this.Noaccesstokens = false;
    } else {
      this.showGeneratedtoken = false;
    }
    //only show token after click createtoken()
    if (this.copytoken == true) {
      this.Noaccesstokens = false;
    }
  }

  generateToken(data:any) {
    
        this.generateForm.title=data
    if (!this.validationService.validateNullUndefinedEmptyString(this.generateForm.title)) {
      this.elementRef.nativeElement.querySelector('.token-error').textContent = "Please fill in the input field";
      return
    }
    if (this.showGeneratedtoken == false) {
      this.showToken = false;
      this.showGeneratedtoken = true;
    }

    this.accessTokenService.generateAccessToken(this.generateForm.title,this.currentUser.email,this.currentUser.name);

    this.accessTokenService.displayTokenKey(this.currentUser.email).subscribe((Response:any)=>{
    this.displayToken=Response.tokens[0];

    })

    this.disaplykeyGenarted =false;

        // this.closeGenerateToken()
        
  }
//   reloadCurrentRoute() {
//     let currentUrl = this.router.url;
    
//     this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
//         this.router.navigate(['/keys']);
//     });
// }

  removeToken(title) {
    // this.disaplykeyGenarted=true
  if(this.Noaccesstokens == false){
    this.Noaccesstokens=true
  }
  else{
    
  }

  if(this.disaplykeyGenarted == false){
this.disaplykeyGenarted = true
  }
   this.accessTokenService.removeAccessToken(title)
   

   this.accessTokenService.getAccessTokens().subscribe((response: any) => {
    this.accessTokenTitles = response.titles || [];
    
  })   
  }
  closeGenerated() {
  
    if (this.copytoken == false) {
      this.copytoken = true;
      this.showGeneratedtoken = false;
    }
    else {
      this.copytoken = false;
      this.showGeneratedtoken = false;

    }
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.displayToken;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  
    this.newToken=null
  this.updateTokens() ;

  
  }

  updateTokens() {

    this.accessTokenService.getAccessTokens().subscribe((response: any) => {
      this.accessTokenTitles = response.titles || [];
      if (this.accessTokenTitles.length === 0) {
        this.copytoken = false;
      }
      else {
        this.copytoken = true;
        this.Noaccesstokens = false;
      }
      if(this.accessTokenTitles.length>0){

         this.disaplykeyGenarted=false

      }
    
    });

    
  }


  // $scope.$on('user.keys.accessTokens.generated', function(event, token) {

  //   $scope.newToken = token
  //   $scope.showGenerated = true

  // })

  
}